import { render, staticRenderFns } from "./WikiSelectModal.vue?vue&type=template&id=b5c07edc"
import script from "./WikiSelectModal.vue?vue&type=script&lang=ts"
export * from "./WikiSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./WikiSelectModal.vue?vue&type=style&index=0&id=b5c07edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports